{#if show && !container.readonly}
  <Input 
    on:click 
    on:change 
    on:focus 
    on:blur
    id={id} 
    type={type} 
    bind:value={value} 
    font-size="md"
    border="none"
    border-bottom="input"
    mt={container.layout==="stacked" ? "nm" : null}
    pt="sm"
    pb="sm"
    line="20px"
    bg="transparent"
    focus-bg="light"
    width={field.size === '100%' ? field.size : (field.size ? field.size+'ch' : null)}
    overflow="hidden"
  />
{/if}

<script>
  import { Input } from 'svelte-stylo';

  export let
    id,
    type,
    container, 
    field,
    value, 
    show=true;

  let borders = {
    'enabled': "input",
    'readonly': null,
    'disabled': '1'
  }

  let colors = {
    'enabled': "dark",
    'readonly': "body",
    'disabled': "muted"
  }
</script>
